import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.SlideInNavigation = function(element) {

        this.$menu = $(element);
        this.$document = $(document);
        this.$body = $('body');
        this.$noClickOverlay = $('.noClickOverlay');
        this.$menuButton = $('.header .onIconMenu');
        this.$slideInNavigation = $('.slideInNavigation');
        this.$closeButton = $('.onIconCloseCircle', this.$slideInNavigation);
        this.$mainContainer = $('.main.container');
        this.$headerContainer = $('.header.container');
        this.$overflowWrapper = $('.overflowWrapper');
        this.$listItems = $('li', this.$slideInNavigation);
        this.$navItems = $('li a', this.$slideInNavigation);
        this.$windowElement = $(window);

        this.pageWrapperTouchListener = null;
        this.touchMoveStartListener = null;
        this.touchMoveListener = null;
        this.menuStatus = 'closed';

        this.scrollOffset = 0;
        this.hasTouchscreen = OndigoNS.Utils.hasTouchscreen();

        if (this.$menuButton.length) {
            this.init();
        }
    };

    OndigoNS.SlideInNavigation.prototype = {
        init: function () {
            var _instance = this;

            this.$windowElement.on('load', function () {
                _instance.setMenuDimension();
            });

            this.$menuButton.add(this.$closeButton).on('click', function () {
                _instance.handleNavigation();
            });

            this.$document.on('scroll', function () {
                if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax) {
                    _instance.setMenuDimension(); // smartphone changes available height on scroll (menu disappears)
                }
            });

            this.presetMenu();

            this.$listItems.find('.submenu').css('min-height', this.$slideInNavigation.height() - 55);

            this.$navItems.addClass('item');
            this.$navItems.on('click', function (e) {
                if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax) {
                    e.preventDefault();
                    var $item = $(this);
                    if ($item.parent().hasClass('sub') && !$item.parents('.submenu').length) {
                        $item.parent().find('.submenu').addClass('clicked');
                        $('.backLink').show();
                    }
                    else {
                        window.location = $item.attr('href');
                    }
                }
            });

            $('.backLink').on('click', function (e) {
                $('ul.clicked').removeClass('clicked');
                $('.backLink').hide();
            });

            if (this.hasTouchscreen) {
                this.$windowElement.on('orientationchange', function () {
                    setTimeout(function () {
                        _instance.setMenuDimension();
                        _instance.presetMenu();
                    }, 100);
                });
            }
            else {
                this.$windowElement.on('resize', function () {
                    setTimeout(function () {
                        _instance.setMenuDimension();
                        //_instance.presetMenu();
                    }, 100);
                });
            }
        },
        presetMenu: function() {
            if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax) {
                if ($('li.active', this.$slideInNavigation).hasClass('sub')) {
                    $('li.active', this.$slideInNavigation).find('.submenu').addClass('clicked');
                    if ($('.submenu li.active', this.$slideInNavigation).length > 0) {
                        $('.backLink', this.$slideInNavigation).show();
                    }
                }
            }
            else {
                $('li.active', this.$slideInNavigation).find('.submenu').removeClass('clicked');
                if ($('li.active', this.$slideInNavigation).length > 0) {
                    $('.backLink', this.$slideInNavigation).hide();
                }
            }
        },
        positioningNavigation: function () {
            this.scrollOffset = this.$document.scrollTop();

            this.$menu.css({
                'margin-top': this.scrollOffset
            });
        },
        setMenuDimension: function () {
            var windowHeight = window.innerHeight !== undefined ? window.innerHeight : this.$windowElement.height(),
                windowWidth = OndigoNS.Utils.getWindowInnerWidth(),
                headerHeight = this.$headerContainer.outerHeight(), // check always because header has variable height
                footerHeight = $('.footer.container').outerHeight();

            if (windowWidth < OndigoNS.breakpointMax) {
                this.$menu.height(windowHeight);

                this.$mainContainer.css({
                    'min-height': windowHeight - headerHeight - footerHeight
                });
            }
            else {
                this.menuStatus = 'closed';
                this.hideNavigation();
            }
        },
        handleNavigation: function () {
            if (this.menuStatus === 'closed') {
                this.showNavigation();
            }
            else {
                this.hideNavigation();
            }
        },
        showNavigation: function () {
            var _instance = this;

            this.$overflowWrapper.addClass('mobileNavVisible');
            this.$listItems.find('.submenu').css('min-height', this.$slideInNavigation.height() - 55);
            this.menuStatus = 'open';

            if (this.hasTouchscreen) {
                this.initializeTouchScrolling();
            }
            this.$body.addClass('noScrolling');
            this.$noClickOverlay.on('click', function() {
                _instance.hideNavigation();
                $(this).unbind();
                return false;
            });
        },
        hideNavigation: function () {
            this.$overflowWrapper.removeClass('mobileNavVisible');

            if (this.hasTouchscreen) {
                if (this.touchMoveStartListener && this.touchMoveStartListener.unbind()) {
                    this.touchMoveStartListener.unbind();
                }
                if (this.touchMoveListener && this.touchMoveListener.unbind()) {
                    this.touchMoveListener.unbind();
                }
                if (this.pageWrapperTouchListener && this.pageWrapperTouchListener.unbind()) {
                    this.pageWrapperTouchListener.unbind();
                }
            }

            this.$noClickOverlay.off('click');
            this.$body.removeClass('noScrolling');
            this.menuStatus = 'closed';
        },
        initializeTouchScrolling: function () {
            var _instance = this;

            // prevent to scroll more than possible in mobile menu
            this.touchMoveStartListener = this.$menu.bind('touchstart', {}, function (event) {
                _instance.currentTouchYScroll = event.originalEvent.touches[0].pageY;
            });

            this.touchMoveListener = this.$menu.bind('touchmove', {}, function (event) {
                if (((event.originalEvent.touches[0].pageY <= _instance.currentTouchYScroll) && _instance.checkIfScrolledToBottom(event)) || (event.originalEvent.touches[0].pageY >= _instance.currentTouchYScroll) && _instance.checkIfScrolledToTop(event)) {
                    event.preventDefault();
                }
            });

            this.pageWrapperTouchListener = $('.pageWrapper').bind('touchmove', {}, function (event) {
                event.preventDefault();
            });
        },
        checkIfScrolledToTop: function(e) {
            var elem = $(e.currentTarget);
            return elem.scrollTop() <= 3;
        },
        checkIfScrolledToBottom: function(e) {
            var elem = $(e.currentTarget);
            return elem[0].scrollHeight - elem.scrollTop() === elem.outerHeight();
        }
    };

    // plugin definition
    $.fn.slideInNavigation = function () {
        return new OndigoNS.SlideInNavigation(this);
    };
    $.fn.slideInNavigation.Constructor = OndigoNS.SlideInNavigation;

}(window.jQuery));


$(document).ready(function () {
    'use strict';

    $('.slideInNavigationWrapper').slideInNavigation();
});
